export enum TechrunProtocolRateType {
  Ton = 'TON',
  Wagon = 'WAGON',
}
